"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;
exports.initialize = exports.getThunk = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _debug = _interopRequireDefault(require("debug"));
var _redux = require("redux");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _middleware = require("../domains/assets/middleware");
var _reducers = _interopRequireDefault(require("../domains/reducers"));
var sessionActions = _interopRequireWildcard(require("../domains/session/actions"));
var _reducerManager = _interopRequireDefault(require("./reducerManager"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isClient = (typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) === 'object';
var log = (0, _debug.default)('exchange:store');
var logError = (0, _debug.default)('exchange:store:error');
var initialize = exports.initialize = function initialize(session) {
  return function (dispatch) {
    dispatch(sessionActions.setSession(session));
    dispatch(sessionActions.setFeatureFlags(session.featureFlags));
  };
};
var getThunk = exports.getThunk = function getThunk() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$errorHandler = _ref.errorHandler,
    errorHandler = _ref$errorHandler === void 0 ? null : _ref$errorHandler,
    _ref$dispatchHandler = _ref.dispatchHandler,
    dispatchHandler = _ref$dispatchHandler === void 0 ? true : _ref$dispatchHandler,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? null : _ref$config;
  return function (_ref2) {
    var dispatch = _ref2.dispatch,
      getState = _ref2.getState;
    return function (next) {
      return function (action) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          skipErrorHandler: function skipErrorHandler() {
            return false;
          }
        };
        if (typeof action === 'function') {
          var promise = action(dispatch, getState, {
            config: config
          });
          if (promise && promise.catch) {
            promise = promise.catch(function (error) {
              if (!options.skipErrorHandler(error)) {
                logError(error);
                var actionFn = function actionFn() {
                  return dispatch(action);
                };
                if (errorHandler) {
                  if (dispatchHandler) {
                    dispatch(errorHandler(error, actionFn));
                  } else {
                    errorHandler(error, actionFn);
                  }
                } else {
                  // eslint-disable-next-line no-console
                  console.error(error);
                }
              }
              return Promise.reject(error);
            });
          }
          return promise;
        }
        if (action) {
          log.apply(void 0, ["Dispatching action ".concat(action.type)].concat((0, _toConsumableArray2.default)(isClient ? [action] : [])));
          return next(action);
        }
        return null;
      };
    };
  };
};
function configureStore() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    errorHandler = _ref3.errorHandler,
    customMiddlewares = _ref3.customMiddlewares,
    reducers = _ref3.reducers,
    initialState = _ref3.initialState,
    session = _ref3.session,
    _ref3$config = _ref3.config,
    config = _ref3$config === void 0 ? _exchangeReactHooks.defaultConfig : _ref3$config;
  var compiledReducers = _objectSpread(_objectSpread({}, (0, _reducers.default)()), reducers);
  var reducerManager = (0, _reducerManager.default)(compiledReducers);
  var middlewares = [getThunk({
    errorHandler: errorHandler,
    dispatchHandler: false,
    config: config
  })].concat((0, _toConsumableArray2.default)(customMiddlewares !== null && customMiddlewares !== void 0 ? customMiddlewares : []), [_middleware.navBarRecentItemsProvider]);
  var finalState;
  if (initialState && Object.keys(initialState).length < Object.keys(compiledReducers).length) {
    var defaultState = reducerManager.reduce(undefined, {
      type: '@DUMMY_LOAD'
    });
    finalState = _objectSpread(_objectSpread({}, defaultState), initialState);
  }
  var middleware = _redux.applyMiddleware.apply(void 0, (0, _toConsumableArray2.default)(middlewares));
  var store = (0, _redux.createStore)(reducerManager.reduce, finalState, middleware); // define type for store with thunk

  store.reducerManager = reducerManager;
  if (session) {
    store.dispatch(initialize(session));
  }
  return store;
}
//# sourceMappingURL=index.js.map